"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownCircleOutline = _interopRequireDefault(require("./IconChevronDownCircleOutline"));
var IconChevronRightCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownCircleOutline.default).withConfig({
  displayName: "IconChevronRightCircleOutline",
  componentId: "c11n-8-107-0__sc-1mu1qof-0"
})(["transform:rotate(270deg);"]);
var _default = IconChevronRightCircleOutline;
exports.default = _default;